import { v4 as uuidv4 } from 'uuid';

export const formatDropzoneAcceptedFiles = (acceptedFiles: File[]) => {
    return acceptedFiles.map(file => ({
        uuid: uuidv4(),
        file: file,
        progress: 0,
    }));
};
